import React from 'react';

export const MenuCardsSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-2">
      {[...Array(24)].map((_, i) => (
        <div 
          key={i} 
          className="flex items-center gap-2.5 p-2.5 bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg animate-pulse"
        >
          {/* Image skeleton */}
          <div className="w-14 h-14 rounded-lg bg-gray-300 flex-shrink-0"></div>
          
          {/* Content skeleton */}
          <div className="flex-1 min-w-0 space-y-2">
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            <div className="h-5 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  );
};
